import { useQuery } from '@tanstack/vue-query'
import { propertyKeys } from '../propertyQueryKeys'
import { getPropertyStatusCounts, type PropertyStatusCountsDto } from '../propertyEndpoints'

export type PropertyStatusCounts = PropertyStatusCountsDto

export function usePropertyStatusCountsQuery() {
  return useQuery({
    queryKey: propertyKeys.statusCounts(),
    queryFn: () => getPropertyStatusCounts(),
    staleTime: 60_000,
  })
}
